import { render, staticRenderFns } from "./guide-without-button-component.vue?vue&type=template&id=c1d06984"
import script from "./guide-without-button-component.vue?vue&type=script&lang=js"
export * from "./guide-without-button-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports